import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { ApplicationFunctions } from "../../../contexts/authContext";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { Result } from "../../../types/Result";

interface IProps {
    show: boolean
    onHide: (businessPartnerGroupId?: number) => void
}

interface BusinessPartnerGroupCreateModel {
    businessPartnerTypeId: number
    accountManagerEmployeeId?: number
    referenceCode?: string
    name: string
}

const CreateBusinessPartnerPopup: React.FC<IProps> = ({ show, onHide }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<BusinessPartnerGroupCreateModel>({
        businessPartnerTypeId: 0,
        name: '',
    });

    const businessPartnerTypes = useSelectListOptions('api/v1/selectlist/BusinessPartnerTypes?active=true&applicationFunction=' + ApplicationFunctions.CreateBusinessPartnerGroup, '-- Select type');
    const employees = useSelectListOptions('api/v1/selectlist/Employees', '-- Select employee');

    function submit() {
        if (formData) {
            DataService
                .create<number>(`api/v1/BusinessPartnerGroups`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide(response.data);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        formData[name] = value;
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'businessPartnerTypeId', label: 'Type', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'name', label: 'Name', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'referenceCode', label: 'Code', labelSize: 3 },
            { name: 'accountManagerEmployeeId', label: 'Account manager', labelSize: 3 },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Create business-partner group'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('businessPartnerTypeId')} options={businessPartnerTypes} />
                <TextboxField {...getFieldProps('name')} />
                <TextboxField {...getFieldProps('referenceCode')} />
                <SelectListField {...getFieldProps('accountManagerEmployeeId')} options={employees} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Create' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default CreateBusinessPartnerPopup;